// extracted by mini-css-extract-plugin
export default {"theme1":"PayoutsIcon_theme1__nqaF7","theme2":"PayoutsIcon_theme2__8uIrF","theme3":"PayoutsIcon_theme3__bvfYx","theme4":"PayoutsIcon_theme4__mvllC"};